import React, { useState,useRef } from 'react';
import Draggable from 'react-draggable';
import { Box, Typography, InputAdornment} from '@mui/material';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneDark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { InlineMath } from 'react-katex';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import 'katex/dist/katex.min.css';
import SendIcon from '@mui/icons-material/Send';
import {CookingPreview} from '../components/CookingSoon'

const AiCircle = ({submitStatus,chatStatus,aiFeedback,getAIFeedback,setAIFeedback,handleChatStatus}) => {
  const [isRectangleVisible, setIsRectangleVisible] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const inputRef = useRef(null);
  

  const handleSendClick = async () => {
    handleChatStatus(true);
  
    if (inputValue.trim() !== '') {
      const aiFeedbackPayload = {
        query: inputValue,
        ...(aiFeedback !== "" && { context: aiFeedback })
      };
      setInputValue(''); // Clear the input field after sending
      setAIFeedback('');
      // i am losing and gaining back focus on the textfield show the place holder after clearing multiple lines of input        
      document.activeElement.blur();
      
      setTimeout(() => {
      inputRef.current?.focus();
      }, 0);
       
        

      
  
      try {        
        const queryResponse = await getAIFeedback(aiFeedbackPayload);
        console.log("queryResponse", queryResponse);
  
        if (queryResponse) {
          setAIFeedback(queryResponse.data.data);
        }
      } catch (error) {
        console.error("Error fetching query feedback:", error);
        setAIFeedback("The AI Model is down right now, please try again later");
        
      }
    }
  };


  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSendClick();
    }
  };

  
  

  
const eventControl = (event) => {


    if (event.type === 'mousemove' ) {
      setIsDragging(true)
    }

    if (event.type === 'mouseup' ) {
      setTimeout(() => {
        setIsDragging(false);
      },1);

    }
  }

 

  const handleClick = () => {
    if(!isDragging){
        setIsRectangleVisible(!isRectangleVisible);

    }
    
  };

  var ww = window.innerWidth,
      wh = window.innerHeight,
      boundLeft = ww-(ww/0.847),
      boundRight = ww-(ww/18),
      boundTop = wh-(wh/0.5),
      boundBottom=wh-(wh/0.88);
  console.log("wwwh",ww,wh); 


  return (    
      <Draggable 
          bounds={{left: boundLeft, top: boundTop, right: boundRight, bottom: boundBottom}} 
          defaultPosition={{ x: ww-(ww/12), y: wh-(wh/0.877)}}          
          onDrag={eventControl} 
          onStop={eventControl}
          
          
          
      >
          <Box 
              sx={{
              width: '80px',
              height: '80px',                          
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              
              position: 'relative',
              zIndex: 1000000,
              }}
          >
              <Box 
                onClick={handleClick} 
                sx={{
                  cursor: 'pointer',                  
                }}
              >
                <svg width="77.7" height="98" viewBox="0 0 111 140" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <ellipse cx="55.5" cy="86.9995" rx="55.5" ry="53.0004" fill="#302E35"/>
                  <path d="M45.3047 85.3285C66.3669 91.101 100.391 64.5385 92.563 16.539C82.7779 -43.4604 79.3553 89.964 45.3047 85.3285Z" fill="#7DB58D" stroke="black"/>
                  <path d="M44.5283 88.6306C64.947 95.778 100.586 97.4613 96.3887 82.203C91.142 63.1302 77.8859 98.8948 44.5283 88.6306Z" fill="#7DB58D" stroke="black"/>
                  <path d="M45.4629 91.3584C59.5713 107.732 89.6291 126.948 93.6708 111.618C98.7228 92.4551 69.2225 116.882 45.4629 91.3584Z" fill="#7DB58D" stroke="black"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M30.2252 63.7047C34.7904 61.2943 39.894 60.1809 44.9721 60.4876C50.0785 60.796 61.1407 62.4806 56.8653 68.3965C54.6922 71.4036 52.5274 70.4614 49.7984 69.2736C48.2081 68.5815 46.4262 67.8059 44.3394 67.6799C40.5778 67.4527 36.7973 68.2774 33.4156 70.0629C30.034 71.8485 27.1828 74.5253 25.1772 77.7976C23.1716 81.0699 22.1328 84.8106 22.094 88.6057L14.9405 88.6057C14.9928 83.4823 16.396 78.5639 19.1035 74.1463C21.811 69.7288 25.66 66.1151 30.2252 63.7047Z" fill="#D9D9D9"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M30.2252 113.459C34.7904 115.87 39.894 116.983 44.9721 116.676C50.0785 116.368 61.1407 114.683 56.8653 108.768C54.6922 105.76 52.5274 106.703 49.7984 107.89C48.2081 108.583 46.4262 109.358 44.3394 109.484C40.5778 109.711 36.7973 108.887 33.4156 107.101C30.034 105.316 27.1828 102.639 25.1772 99.3665C23.1716 96.0942 22.1328 92.3535 22.094 88.5584L14.9405 88.5584C14.9928 93.6817 16.396 98.6002 19.1035 103.018C21.811 107.435 25.66 111.049 30.2252 113.459Z" fill="#D9D9D9"/>
                  <ellipse cx="33.024" cy="86.1095" rx="3.45757" ry="6.0538" fill="#D9D9D9"/>
                  <ellipse cx="44.4732" cy="86.1095" rx="3.45757" ry="6.0538" fill="#D9D9D9"/>
                  <ellipse cx="55.5" cy="86.9995" rx="55.5" ry="53.0004" fill="#302E35"/>
                  <path d="M45.3047 85.3285C66.3669 91.101 100.391 64.5385 92.563 16.539C82.7779 -43.4604 79.3553 89.964 45.3047 85.3285Z" fill="#7DB58D"/>
                  <path d="M44.5283 88.6306C64.947 95.778 100.586 97.4613 96.3887 82.203C91.142 63.1302 77.8859 98.8948 44.5283 88.6306Z" fill="#7DB58D"/>
                  <path d="M45.4629 91.3584C59.5713 107.732 89.6291 126.948 93.6708 111.618C98.7228 92.4551 69.2225 116.882 45.4629 91.3584Z" fill="#7DB58D"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M30.2252 63.7047C34.7904 61.2943 39.894 60.1809 44.9721 60.4876C50.0785 60.796 61.1407 62.4806 56.8653 68.3965C54.6922 71.4036 52.5274 70.4614 49.7984 69.2736C48.2081 68.5815 46.4262 67.8059 44.3394 67.6799C40.5778 67.4527 36.7973 68.2774 33.4156 70.0629C30.034 71.8485 27.1828 74.5253 25.1772 77.7976C23.1716 81.0699 22.1328 84.8106 22.094 88.6057L14.9405 88.6057C14.9928 83.4823 16.396 78.5639 19.1035 74.1463C21.811 69.7288 25.66 66.1151 30.2252 63.7047Z" fill="#D9D9D9"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M30.2252 113.459C34.7904 115.87 39.894 116.983 44.9721 116.676C50.0785 116.368 61.1407 114.683 56.8653 108.768C54.6922 105.76 52.5274 106.703 49.7984 107.89C48.2081 108.583 46.4262 109.358 44.3394 109.484C40.5778 109.711 36.7973 108.887 33.4156 107.101C30.034 105.316 27.1828 102.639 25.1772 99.3665C23.1716 96.0942 22.1328 92.3535 22.094 88.5584L14.9405 88.5584C14.9928 93.6817 16.396 98.6002 19.1035 103.018C21.811 107.435 25.66 111.049 30.2252 113.459Z" fill="#D9D9D9"/>
                  <ellipse cx="33.024" cy="86.1095" rx="3.45757" ry="6.0538" fill="#D9D9D9"/>
                  <ellipse cx="44.4732" cy="86.1095" rx="3.45757" ry="6.0538" fill="#D9D9D9"/>
                </svg>

              </Box>
              
              {submitStatus && aiFeedback !== "" && !isRectangleVisible && (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center', 
                  alignItems: 'center',
                  borderRadius: "30px",
                  border: "1.5px solid #5D2A79",
                  background: "#FFF",
                  boxShadow:"10px 10px 80px 0px rgba(63, 39, 102, 0.15)",
                  position: 'absolute',
                  top: '-50px', 
                  left: '-60px',  
                  width: '170px',
                  height: '50px',
                  fontWeight: "600",
                  fontSize: "20px",
                  
                  
                }}
              > 
                <Box sx={{color: "#414042",marginRight:"5px"}}>
                  Check
                </Box>
                <Box sx={{
                    background: 'var(--algo-olio-gradient-dark, linear-gradient(317deg, #A29EDA -26.21%, #B292D1 -10.9%, #B557AF 38.67%, #6B3A8F 78.77%, #5D2A79 115.46%))',
                    backgroundClip: 'text',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                  }}  
                >                  
                  Insights!
                </Box> 
              </Box>
              )}
              {isRectangleVisible && (
              <Box
                  sx={{
                      position: 'absolute',
                      top: '-580px', 
                      left: '-420px',  
                      width: '450px',
                      height: '600px',
                      borderRadius: '24px',
                      border: '1.5px solid #5D2A79',
                      backgroundColor: '#1D151D',
                      boxShadow: '10px 10px 80px 0px rgba(63, 39, 102, 0.15)',
                      
                  }}
              >  
                
                <Box sx={{
                  color:"#E1E1E6", 
                  margin:'20px',
                  marginBottom:'0',                    
                  fontSize: '22px',                    
                  fontWeight: '700',
                  lineHeight: '140%',
                  display:'flex'
                  }}>
                    <Box>
                      <svg 
                        width="24" 
                        height="24" 
                        viewBox="0 0 28 27"                      
                        fill="none" 
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ maxWidth: '100%', height: 'auto',marginRight:"10px" }} // Ensures responsiveness
                      >
                        <mask id="mask0_4159_155" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="28" height="27">
                          <path d="M27.4615 12.1852L20.1329 9.49012L17.3963 0.579274C17.2909 0.235637 16.9706 0 16.609 0C16.2475 0 15.9271 0.235637 15.8217 0.579274L13.086 9.49012L5.75652 12.1852C5.43287 12.3047 5.21875 12.6099 5.21875 12.9527C5.21875 13.2947 5.43287 13.6015 5.75652 13.7201L13.0818 16.4144L15.8193 25.5969C15.923 25.9438 16.2442 26.1819 16.609 26.1819C16.973 26.1819 17.295 25.9438 17.3988 25.5961L20.1362 16.4136L27.4624 13.7193C27.7844 13.6015 27.9993 13.2955 27.9993 12.9527C27.9993 12.6107 27.7844 12.3047 27.4615 12.1852Z" fill="url(#paint0_linear_4159_155)"/>
                          <path d="M10.9917 21.1859L9.08603 20.4855L8.34485 17.7855C8.24768 17.4288 7.92238 17.1817 7.55097 17.1817C7.17955 17.1817 6.85426 17.4288 6.75626 17.7847L6.01508 20.4847L4.11025 21.1851C3.7866 21.3037 3.57248 21.6105 3.57248 21.9525C3.57248 22.2945 3.7866 22.6013 4.11025 22.72L6.0052 23.4179L6.75214 26.3814C6.84438 26.7446 7.17297 26.9999 7.55097 26.9999C7.92897 26.9999 8.25756 26.7446 8.34979 26.3805L9.09674 23.4171L10.9917 22.7192C11.3153 22.6013 11.5295 22.2945 11.5295 21.9525C11.5295 21.6105 11.3153 21.3037 10.9917 21.1859ZM7.4192 3.46156L5.47237 2.74565L4.75096 0.810641C4.63155 0.489095 4.32354 0.276367 3.97848 0.276367C3.63425 0.276367 3.32625 0.489095 3.20601 0.810641L2.48542 2.74565L0.537767 3.46156C0.214118 3.58101 0 3.88701 0 4.22902C0 4.57102 0.214118 4.87784 0.537767 4.99647L2.48542 5.71238L3.20601 7.64739C3.32625 7.96894 3.63425 8.18166 3.97848 8.18166C4.32272 8.18166 4.63072 7.96894 4.75096 7.64739L5.47155 5.71238L7.4192 4.99647C7.74285 4.87702 7.95697 4.57102 7.95697 4.22902C7.95697 3.88701 7.74285 3.58101 7.4192 3.46156Z" fill="#FFCC4D"/>
                        </mask>
                        <g mask="url(#mask0_4159_155)">
                          <rect y="-3.5166" width="28" height="33.1989" fill="url(#paint1_linear_4159_155)"/>
                        </g>
                        <defs>
                          <linearGradient id="paint0_linear_4159_155" x1="16.609" y1="0" x2="16.609" y2="26.1819" gradientUnits="userSpaceOnUse">
                            <stop stopColor="#FFAC33"/>
                            <stop offset="1" stopColor="#99671F"/>
                          </linearGradient>
                          <linearGradient id="paint1_linear_4159_155" x1="14" y1="-3.5166" x2="14" y2="29.6823" gradientUnits="userSpaceOnUse">
                            <stop stopColor="#FFF838"/>
                            <stop offset="1" stopColor="#F4BF9A"/>
                          </linearGradient>
                        </defs>
                      </svg>
                    </Box>
                    
                    AI Insights
                </Box>                  
                <Box>
                  <Box sx={{
                      backgroundColor: "#1D151D",
                      width: "95%",
                      minHeight:"450px",
                      maxHeight: "450px",
                      overflowY: "auto",
                      marginTop: "10px",
                      marginLeft: '7px',
                      borderRadius: '4px',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'flex-start',
                      padding: '10px'
                  }}>
                    
                    {(!chatStatus) ? (
                      <Typography sx={{ color: "white", marginLeft: "7px", fontSize:'18px' }}>
                        Either submit code and ask me a question
                      </Typography>
                    ) : (aiFeedback === "") ? (
                      <CookingPreview insights={true}/>
                    ) : (
                      (() => {                        
                        const lines = aiFeedback.split('\n');
                        const elements = [];
                        let isInCodeBlock = false;
                        let codeContent = [];
                        
                        for (let i = 0; i < lines.length; i++) {
                          const line = lines[i];
                          
                          // Handle code blocks
                          if (line.startsWith('```')) {
                            if (!isInCodeBlock) {
                              isInCodeBlock = true;
                              continue;
                            } else {
                              isInCodeBlock = false;
                              elements.push(
                                <Box sx={{ width: '100%' }}>
                                  <SyntaxHighlighter 
                                    key={`code-${i}`}
                                    language="python" 
                                    style={oneDark}
                                  >
                                    {codeContent.join('\n')}
                                  </SyntaxHighlighter>
                                </Box>
                              );
                              codeContent = [];
                              continue;
                            }
                          }

                          if (isInCodeBlock) {
                            codeContent.push(line);
                            continue;
                          }

                          // Handle headers
                          if (line.startsWith("###")) {
                            elements.push(
                              <Typography
                                key={`text-${i}`}
                                variant="h6"
                                sx={{ color: "white", fontWeight: "bold", marginTop: 0, marginBottom: 1 }}
                              >
                                {line.replace(/###/g, '').trim()}
                              </Typography>
                            );
                            continue;
                          }

                          // Handle bold text
                          const formattedLine = line.split(/(\*\*[^*]+\*\*)/).map((part, j) => {
                            if (part.startsWith("**") && part.endsWith("**")) {
                              return (
                                <Typography component="span" sx={{ fontWeight: "bold" }} key={j}>
                                  {part.replace(/\*\*/g, '')}
                                </Typography>
                              );
                            } else if (part.includes('\\(') && part.includes('\\)')) {
                              return (
                                <InlineMath key={j}>
                                  {part.replace(/\\\(/g, '').replace(/\\\)/g, '')}
                                </InlineMath>
                              );
                            } else {
                              return (
                                <Typography component="span" key={j}>
                                  {part}
                                </Typography>
                              );
                            }
                          });

                          elements.push(
                            <Typography
                              key={`text-${i}`}
                              sx={{ color: "white", marginLeft: "7px", marginTop: 0.5, marginBottom: 0.5 }}
                            >
                              {formattedLine}
                            </Typography>
                          );
                        }
                        
                        return elements;
                      })()
                    )}
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '100%',                                           
                      padding: '10px',                      
                      
                      
                    }}
                  >
                    <TextField  
                      inputRef={inputRef}                    
                      variant="outlined"
                      multiline                      
                      maxRows={2}
                      placeholder="Message Oli..."
                      value={inputValue}
                      onChange={(e) => setInputValue(e.target.value)}
                      onKeyDown={handleKeyDown}
                      sx={{
                        flexGrow: 1,
                        marginRight: '10px',                        
                        backgroundColor: '#1D151D',
                        input: { color: 'white' },
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor: '#5D2A79',
                          },
                          '&:hover fieldset': {
                            borderColor: '#7D4A99',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#9D6AB9',
                          },
                        },
                        '& .MuiInputBase-input': {
                          color: 'white', // Text color
                        },
                        '& .MuiInputBase-input::placeholder': {
                          color: 'white', // Placeholder color
                        },
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <SendIcon 
                              sx={{ color: 'white', cursor: 'pointer' }} 
                              onClick={handleSendClick}
                            />
                            
                          </InputAdornment>
                        ),
                      }}
                    />                   
                  </Box>
                </Box>
                
              </Box>
              )}
          </Box>
          
      </Draggable>
    
  );
};

export default AiCircle;
